module.exports = __webpack_public_path__ + "img/37_57.6d69cf4a.png";